import Splitter from "./Splitter";

export default Splitter;
